<template>
    <v-container fluid class="align-center column" style="height: auto">
        <div class="path align-center">
            <div class="row screen-width" style="height: 24px; gap: 24px">
                <HomeOutline :size="24"></HomeOutline>
                <ChevronRight :size="24"></ChevronRight>
                <p>공지사항</p>
            </div>
        </div>

        <div id="product-select" class="column screen-width">
            <p style="font-size: 32px; font-weight: bold">공지사항</p>
            <div style="width: 100%; height: 2px; background: black"></div>
        </div>

        
        <div id="data" class="screen-width">
            <div id="data-list">
                <!-- <question-list-item
                    v-for="qna in qnaList"
                    :key="qna"
                    :title="qna.title"
                    :category="'분류'"
                    :date="qna.createdAt"
                    :id="qna.id"
                    :completed="qna.completed"
                ></question-list-item> -->
                <p> 준비중</p>
            </div>
            <custom-pagination
                style="margin-top: 32px"
                :currentPage="currentPage"
                :totalPages="totalPages"
                v-on:update="loadPageData"
            ></custom-pagination>
        </div>
    </v-container>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import HomeOutline from "vue-material-design-icons/HomeOutline.vue";
import ChevronRight from "vue-material-design-icons/ChevronRight.vue";
import TextButton from "@/components/TextButton.vue";
import SearchBar from "@/components/SearchBar.vue";
import QuestionListItem from "@/components/QuestionListItem.vue";
import CustomPagination from "@/components/CustomPagination.vue";

export default {
    name: "problem-layout",
    components: {
        HomeOutline,
        ChevronRight,
        TextButton,
        SearchBar,
        CustomPagination,
        QuestionListItem,
    },
    setup() {
        const store = useStore();
        const router = useRouter();
        const categoryList = [
            "전체",
            "GPS플로터",
            "레이더",
            "무선/통신장비",
            "항해 안전장비",
            "항해 조타장비",
            "해상용 안테나/헤딩센서",
            "선박용 인산철배터리",
            "선박용 전기관련 제품",
            "부품 및 액세서리",
        ];

        const categoryValue = [null, 0, 1, 2, 3, 4, 5, 6, 7, 8];

        const selectedCategory = ref(0);

        const search = ref(null);

        const user_id = ref(null);

        const selectedMyQna = ref(false);

        const downloadList = computed(() => {
            return store.getters.getDownloadList;
        });

        const qnaList = computed(() => {
            return store.getters.getQnaList;
        });

        const selectCategory = async (index) => {
            selectedCategory.value = index;
            await store.dispatch("getSubCategoryList", index);
            getQnaList();
        };

        const currentPage = ref(1);
        const totalPages = computed(() => {
            return Math.ceil(store.getters.getQnaTotalCount / 10)
        });
        const loadPageData = (page) => {
            currentPage.value = page;
            getQnaList();
        };

        const getQnaList = () => {
            store.dispatch("getQnaList", {
                userId: selectedMyQna.value ? user_id.value : null,
                main_category: categoryValue[selectedCategory.value],
                take: 10,
                search: search.value,
                page: currentPage.value,
            });
        }   

        const searchQna = (word) => {
            search.value = word
            getQnaList();
        };

        const createQna = () => {
            if (!user_id.value) {
                alert("로그인이 필요합니다.");
                return;
            }
            router.push({ path: "/add/qna" });
        };

        const moveQnaPage = (id) => {
            router.push({ path: `/customer/qna/${id}` });
        };

        const findMyQna = () => {
            if (!user_id.value) {
                alert("로그인이 필요합니다.");
                return;
            }
            selectedMyQna.value = !selectedMyQna.value;
            getQnaList();
        }

        onMounted(async () => {
            getQnaList();
            try {
                const userProfile = await store.dispatch("getUserProfile");
                user_id.value = userProfile.id;
            } catch (err) {
                console.log(err);
            }
        });

        return {
            selectCategory,
            selectedCategory,
            currentPage,
            totalPages,
            loadPageData,
            categoryList,
            downloadList,
            qnaList,
            searchQna,
            moveQnaPage,
            createQna,
            findMyQna,selectedMyQna
        };
    },
};
</script>

<style scoped>
/* 화면 너비가 601px에서 900px 사이인 경우 */
@media (min-height: 601px) and (max-height: 850px) {
    .sensor-title {
        font-size: 0.675rem;
        padding: 2px 15px;
    }

    .sensor-value {
        padding: 5px 15px;
        font-size: 1rem;
    }
}

.selected {
    color: #00a7e7;
    font-weight: bold;
}

#product-select {
    padding: 40px 0px;
    gap: 24px;
    flex-wrap: wrap;
}

#product-list {
    width: 100%;
    height: auto;
    background: #f4f4f4;
    border-radius: 10px;
    border: 1px solid #d9d9d9;
    padding: 30px;
    gap: 16px;
    flex-wrap: wrap;
}


#data {
    padding-bottom: 20px;
}

#data-list {
    width: 100%;
}

#search {
    padding: 32px 0px;
    gap: 24px;
}
.text_button {
    padding: 8px 16px;
    border: 1px solid black;
    border-radius: 20px;

}
.selected_button {
    border: 2px solid #00a7e7;
    color :  #00a7e7
}
</style>
